import connectionProxy from './connectionProxy'

const {
  REACT_APP_API_SSO_LOGIN_URL,
  REACT_APP_API_SSO_LOGOUT_URL,
  REACT_APP_API_TOKEN
} = process.env

export const redirectToSignIn = () => {
  window.location.href = REACT_APP_API_TOKEN
    ? `/login/${REACT_APP_API_TOKEN}`
    : REACT_APP_API_SSO_LOGIN_URL
}

export const redirectToSignOut = () => {
  setTimeout(() => {
    window.location.href = REACT_APP_API_SSO_LOGOUT_URL
  }, 1000)
}

export const getAuthorization = token => {
  return connectionProxy.http.post('/auth/sign_in', {
    token
  })
}



// WEBPACK FOOTER //
// ./src/api/auth.js